<div class="w-full" style="overflow: visible; padding: 0;">
  @if (events() && events().length > 0) {
    <p-carousel
      [value]="events()"
      [numVisible]="numVisible()"
      [numScroll]="numScroll()"
      [responsiveOptions]="responsiveOptions()"
      [circular]="events().length > 1"
      [autoplayInterval]="events().length > 1 ? 9000 : 0"
      [showIndicators]="events().length > 1"
      [showNavigators]="false"
      styleClass="custom-carousel"
    >
      <ng-template let-event pTemplate="item">
        <div class="carousel-item-wrapper">
          <app-card-event class="compact block relative z-1 w-full md:w-23rem lg:w-24rem carousel-card"
            [card]="{
              src: event.src || event.image,
              day: event.day?.padStart(2, '0') || '00',
              title: event.title || event.name,
              month: event.month || 'JAN',
              city: event.city || '',
              state: event.state || '',
              local: event.local
            }"
            borderRadius="1rem"
            [id]="event.id"
            [route]="['/eventos/detalhe', event.slugUrl]"
           />
        </div>
      </ng-template>
    </p-carousel>
  }
</div>
